'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var disableSelect = function disableSelect() {
  var customStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    borderColor: '#e0e0e0',
    color: '#e0e0e0',
    cursor: 'not-allowed'
  }, customStyles);
};
var StyledSelect = styled.select.withConfig({
  componentId: "sc-1o6thpp-0"
})(["width:", ";min-width:", ";height:", ";border-style:", ";border-color:", ";border-width:", ";border-radius:", ";cursor:", ";padding-left:", ";padding-right:", ";outline-width:", ";font-size:", ";color:", ";"], function (props) {
  return props.s.width || '100%';
}, function (props) {
  return props.s.minWidth || '6.25rem';
}, function (props) {
  return props.s.height || '2.5rem';
}, function (props) {
  return props.s.borderStyle || 'solid';
}, function (props) {
  return props.s.borderColor || '#999';
}, function (props) {
  return props.s.borderWidth || '0.0625rem';
}, function (props) {
  return props.s.borderRadius || '0.125rem';
}, function (props) {
  return props.s.cursor || 'auto';
}, function (props) {
  return props.s.paddingLeft || '0.75rem';
}, function (props) {
  return props.s.paddingRight || '0.75rem';
}, function (props) {
  return props.s.outlineWidth || '0';
}, function (props) {
  return props.s.fontSize || '0.875rem';
}, function (props) {
  return props.s.color || '#666';
});
var SelectList = function SelectList(_ref) {
  var className = _ref.className,
    s = _ref.s,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledSelect, {
    className: className,
    s: disabled ? disableSelect(s) : s,
    defaultValue: value || defaultValue,
    disabled: disabled,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  }, children);
};
SelectList.propTypes = {
  className: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    minWidth: PropTypes.string,
    height: PropTypes.string,
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    borderRadius: PropTypes.string,
    paddingLeft: PropTypes.string,
    paddingRight: PropTypes.string,
    outlineWidth: PropTypes.string,
    fontSize: PropTypes.string,
    color: PropTypes.string
  }),
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  children: PropTypes.node.isRequired
};
SelectList.defaultProps = {
  className: '',
  s: {},
  value: undefined,
  defaultValue: undefined,
  disabled: false,
  onChange: function onChange(data) {
    return data;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onBlur: function onBlur() {
    return undefined;
  }
};

exports.default = SelectList;
exports.disableSelect = disableSelect;
